import { Component, OnInit, Input, Inject, Output, EventEmitter } from '@angular/core';
import { ActionButton } from '@app/shared/models/action-button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-modal-alert',
  templateUrl: './modal-alert.component.html',
  styleUrls: ['./modal-alert.component.scss']
})
export class ModalAlertComponent implements OnInit {
  @Input() message: string;
  @Input() error: string;
  @Input() questionConfirm: string;
  @Input() buttons: ActionButton[] = [];

  @Output() acceptFN: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelFN: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private dialogRef: MatDialogRef<ModalAlertComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any) {

    this.error = this.data.error;
    this.message = this.data.message;
    this.questionConfirm = this.data.questionConfirm;
  }

  ngOnInit() {
  }

  accept(): void {
    this.acceptFN.emit(true);
  }

  close(update: boolean = false): void {
    this.dialogRef.close(update);
    this.cancelFN.emit(true);
  }
}
